import { assert_instanceof, assert_type_enum, assert_type_object, assert_type_string } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { FN_SERIALIZATION__data_deserialize } from '@shared/serialization/FN_SERIALIZATION__data_deserialize';
import { logw } from '@shared/utils/utils_logs';
import { ENUM__control_net_type } from '../_enums/ENUM__control_net_type';
import { ENUM__ml_asset_config_key } from '../_enums/ENUM__ml_asset_config_key';
import { ENUM__ml_asset_generator_unet } from '../_enums/ENUM__ml_asset_generator_unet';
import { ENUM__ml_asset_type } from '../_enums/ENUM__ml_asset_type';
import { ENUM__t2i_adapter_type } from '../_enums/ENUM__t2i_adapter_type';
import { DTO__ml_asset_lora_tag_frequency } from './DTO__ml_asset_lora_tag_frequency';

const { URL_SOURCE_DELIMETER } = CONSTANTS__shared;

export class DTO__ml_asset_config {
  /*
   * STATIC FIELDS
   */

  /*
   * STATIC FIELDS DESERIALIZATION
   */

  /*
   * STATIC METHODS
   */

  /*
   * PROPERTIES
   */

  get_embedding__is_sign_positive() {
    this.warn_if_different_type([ENUM__ml_asset_type.EMBEDDING]);

    let out = this.get_config_dictionary().get_or_default(ENUM__ml_asset_config_key.EMBEDDING__SIGN_IS_POSITIVE, 'true');

    assert_type_string(out);

    return out.to_boolean();
  }

  get_lora__is_lcm() {
    this.warn_if_different_type([ENUM__ml_asset_type.LORA]);

    let out = this.get_config_dictionary().get_or_default(ENUM__ml_asset_config_key.LORA__IS_LCM, 'false');

    assert_type_string(out);

    return out.to_boolean();
  }

  get_unet_is_inpaint() {
    this.warn_if_different_type([ENUM__ml_asset_type.UNET]);

    let out = this.get_config_dictionary().get_or_default(ENUM__ml_asset_config_key.UNET__TYPE, ENUM__ml_asset_generator_unet.NORMAL);

    assert_type_enum(out, ENUM__ml_asset_generator_unet);

    return out == ENUM__ml_asset_generator_unet.INPAINT;
  }

  get_control_net_type(): ENUM__control_net_type {
    this.warn_if_different_type([ENUM__ml_asset_type.CONTROL_NET]);

    let out = this.get_config_dictionary().get_or_assert(ENUM__ml_asset_config_key.CONTROL_NET_TYPE);

    assert_type_enum(out, ENUM__control_net_type);

    return out;
  }
  get_t2i_adapter_type(): ENUM__t2i_adapter_type {
    this.warn_if_different_type([ENUM__ml_asset_type.T2I_ADAPTER]);

    let out = this.get_config_dictionary().get_or_assert(ENUM__ml_asset_config_key.T2I_ADAPTER__TYPE);

    assert_type_enum(out, ENUM__t2i_adapter_type);

    return out;
  }

  get_config_dictionary() {
    if (!this._config_dictionary.is_stub()) return this._config_dictionary;

    this._config_dictionary = new MAP__serializable();

    let config_parts = this.config_string.split(URL_SOURCE_DELIMETER);

    for (let part of config_parts) {
      let [key, value] = part.split('=');

      this._config_dictionary.set(key, value);
    }

    return this._config_dictionary;
  }

  get_lora__tag_frequency() {
    this.warn_if_different_type([ENUM__ml_asset_type.LORA]);

    let config_value = this.get_config_dictionary().get_or_default(ENUM__ml_asset_config_key.LORA__TAG_FREQUENCY, '{}');
    assert_type_string(config_value);

    let data_raw = JSON.parse(config_value);
    assert_type_object(data_raw);

    let out = [];

    for (let value of Object.values(data_raw)) {
      let item = FN_SERIALIZATION__data_deserialize(value);
      assert_instanceof(item, DTO__ml_asset_lora_tag_frequency);

      out.push(item);
    }

    return out;
  }

  /*
   * FIELDS
   */
  ml_asset_type!: ENUM__ml_asset_type;
  config_string!: string;

  _config_dictionary!: MAP__serializable<string, any>;

  /*
   * METHODS
   */

  constructor() {
    this._config_dictionary = MAP__serializable.CREATE_STUB() as MAP__serializable<string, any>;
  }

  is_valid_for_environment(environment_current: ENUM__environment_type) {
    let out = this.get_config_dictionary().get_or_default(ENUM__ml_asset_config_key.COMMON__ENVIRONMENT, environment_current);

    assert_type_enum(out, ENUM__environment_type);

    return out == environment_current;
  }

  warn_if_different_type(desire_ml_asset_types: ENUM__ml_asset_type[]) {
    if (this.ml_asset_type == ENUM__ml_asset_type.BUNDLE) return;
    if (desire_ml_asset_types.includes(this.ml_asset_type)) return;

    logw(`⚠️  model asset type mismatch:\t${this.ml_asset_type}\tdesired types:\t${JSON.stringify(desire_ml_asset_types)}`);
  }
}
